module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/SummerDay/Nagano_SummerDay_MRI_RCP85_End.png";